import React, { Component } from 'react'

class FlickitySlider extends Component {
  render() {
    return (
      <div className={`flickity-carousel ${this.props.className} -mx-4`}
      >
        { this.props.children }
      </div>
    )
  }
}

FlickitySlider.defaultProps = {
  className: '',
}

export default FlickitySlider
